import styles from "./GridLines.module.scss";

type GridLinesProps = {
  linePositions: number[];
  chartWidth: number;
  strokeWidth: number;
  /** Left edge to start lines from, so they don't run under a reserved value-axis label column. */
  xOffset?: number;
};

const GridLines = ({
  linePositions,
  chartWidth,
  strokeWidth,
  xOffset = 0
}: GridLinesProps) => (
  <g pointerEvents="none">
    {linePositions.map((lineY) => (
      <line
        key={`grid-line-${lineY}`}
        className={styles.gridLine}
        x1={xOffset}
        y1={lineY}
        x2={chartWidth}
        y2={lineY}
        strokeWidth={strokeWidth}
      />
    ))}
  </g>
);

export default GridLines;
